export default __webpack_public_path__ + "static/media/Arrow.c77e71b4.svg";